export const pkg = {
  name: '@ashishkumar472/cf-git',
  version: '1.0.4',
  agent: 'git/cf-git@1.0.4',
}
